import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../sections/Header";
import Sidebar from "../sections/Sidebar";
import { encStorage } from "../hooks/encStorage";
import {
  GET_DEPOSITS,
  GET_DEPOSIT_BANKS,
  POST_TRANSACTION,
  UPLOAD_ATTACHMENT,
} from "../services/Apis";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Deposit = () => {
  const [SidebarState, setSidebarState] = useState(false);
  const [loading, setLoading] = useState(true);
  const [banks, setBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [referenceNumber, setReferenceNumber] = useState("");
  const [attachment, setAttachment] = useState("");
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [amtValidation, setAmtValidation] = useState("");
  const [refValidation, setRefValidation] = useState("");
  const [amount, setAmount] = useState("");
  const navigate = useNavigate();

  const updateSidebarState = (newState) => {
    setSidebarState(newState);
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    setAmount(value);
    if (value < 500) {
      setAmtValidation("Minimum Amount for Deposit should be 500.");
    } else {
      setAmtValidation("");
    }
  };

  const handleNextClick = async () => {
    if (amount >= 500) {
      try {
        const token = encStorage.getItem("token");
        const response = await axios.get(GET_DEPOSIT_BANKS, {
          params: { amount }, // Replace with actual brand_id
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setBanks(response.data.banks);
        if (response.data.banks.length > 0) {
          setSelectedBank(response.data.banks[0].id);
        }
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    } else {
      setAmtValidation("Minimum Amount for Deposit should be 500.");
    }
  };

  const handleBankSelect = (bankId) => {
    setSelectedBank(bankId);
  };

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    setAttachmentFile(file);

    const formData = new FormData();
    formData.append("file", file);

    try {
      const token = encStorage.getItem("token");
      const response = await axios.post(UPLOAD_ATTACHMENT, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      setAttachment(response.data.file[0].file_path);
    } catch (error) {
      console.error("Error occurred while uploading the file:", error);
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const token = encStorage.getItem("token");
    if (!referenceNumber && !attachmentFile) {
      setRefValidation(
        "Please provide either a Transaction Ref. No./UTR No. or Attachment."
      );
      return;
    }
    const formData = new FormData();
    formData.append("amount", amount);
    formData.append("bank_id", selectedBank);
    formData.append("reference_number", referenceNumber);
    formData.append("attachment", attachment);
    formData.append("transaction_type", 0);

    try {
      await axios.post(POST_TRANSACTION, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      navigate("/deposits", {
        state: { message: "Deposit created successfully!", status: 200 },
      });
    } catch (error) {
      //console.error("Error occurred while uploading the file:", error);
      if (error.response && error.response.data && error.response.data.message) {
        navigate("/deposits", {
          state: { message: error.response.data.message, status: error.response.status },
        });
      } else {
        navigate("/deposits", {
          state: { message: "An unexpected error occurred.", status: 400 },
        });
      }
    }
  };

  return (
    <>
      <Header updateState={updateSidebarState} />
      <div id="layoutSidenav">
        <Sidebar props={SidebarState} />
        <div id="layoutSidenav_content" className="layout-content">
          <main>
            <div className="container-fluid px-4">
              <div className="d-flex">
                <h3 className="mt-4 w-75">Add Deposit</h3>
                <div className="mt-auto me-0 mb-2 w-25 d-flex justify-content-end">
                  <Link to="/deposits" className="btn btn-primary" title="New">
                    <span className="d-md-inline">Back</span>
                  </Link>
                </div>
              </div>
              <div className="card mb-4">
                <div className="card-body">
                  <form
                    id="depositform"
                    method="POST"
                    encType="multipart/form-data"
                    onSubmit={handleFormSubmit}
                  >
                    <div className="row">
                      {!banks.length && (
                        <div
                          className="form-group col-sm-6"
                          id="amount-section"
                        >
                          <label htmlFor="amount">Amount</label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Amount"
                            id="amount"
                            value={amount}
                            onChange={handleAmountChange}
                            required
                          />
                          <input type="hidden" name="currency_id" value="113" />
                          <p id="amtValidation" className="text-danger fs-6">
                            {amtValidation}
                          </p>
                          <button
                            type="button"
                            id="next-button"
                            className={`btn btn-primary mt-3 ${
                              amount < 500 ? "disabled" : ""
                            }`}
                            onClick={handleNextClick}
                          >
                            Next
                          </button>
                        </div>
                      )}

                      {banks.length > 0 && (
                        <>
                          <div
                            className="form-group col-sm-12"
                            id="bank-section"
                          >
                            <label htmlFor="bank-cards">Available Banks</label>
                            <div
                              id="bank-cards"
                              className="d-flex flex-wrap gap-3"
                            >
                              {banks.map((bank) => (
                                <div
                                  key={bank.id}
                                  className={`card p-3 border rounded bank-card ${
                                    selectedBank === bank.id
                                      ? "border-primary"
                                      : ""
                                  }`}
                                  style={{ width: "18rem", cursor: "pointer" }}
                                  onClick={() => handleBankSelect(bank.id)}
                                >
                                  <img
                                    src={bank.qr}
                                    className="card-img-top"
                                    alt="Bank QR Code"
                                  />
                                  <div className="card-body">
                                    <p className="card-title">
                                      {bank.description
                                        .split("\n")
                                        .map((line, index) => (
                                          <React.Fragment key={index}>
                                            {line}
                                            <br />
                                          </React.Fragment>
                                        ))}
                                    </p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>

                          <div id="additional-fields">
                            <div className="form-group col-sm-6">
                              <label htmlFor="amount">Amount</label>
                              <input
                                type="text"
                                className="form-control"
                                id="amount"
                                value={amount}
                                readOnly
                              />
                            </div>

                            <input
                              type="hidden"
                              name="transaction_date"
                              className="form-control"
                              value={new Date().toISOString().split("T")[0]}
                            />

                            <div className="form-group col-sm-6">
                              <label htmlFor="reference_number">
                                Transaction Ref. No./UTR No.
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="reference_number"
                                value={referenceNumber}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*$/.test(value)) {
                                    setReferenceNumber(value);
                                    if (value.length < 12) {
                                      setRefValidation(
                                        "Reference number must be at least 12 digits."
                                      );
                                    }else if(value.length > 12){
                                      setRefValidation(
                                        "Reference number should not be more than 12 digits."
                                      );
                                    } else {
                                      setRefValidation("");
                                    }
                                  }
                                }}
                              />
                              <p
                                id="refValidation"
                                className="text-danger fs-6"
                              >
                                {refValidation}
                              </p>
                            </div>

                            <div className="form-group col-sm-6">
                              <label htmlFor="attachmentInput">
                                Attachment
                              </label>
                              <input
                                type="file"
                                className="form-control"
                                id="attachmentInput"
                                accept="image/jpeg, image/png, image/gif"
                                onChange={handleFileChange}
                              />
                              <input
                                type="hidden"
                                name="attachment"
                                className="form-control"
                                id="attachment"
                                value={attachment}
                              />
                              <div id="loader" className="d-none">
                                <i className="fa fa-spinner fa-spin"></i>{" "}
                                Uploading...
                              </div>
                              <div className="attachment-view mt-2"></div>
                              {attachment && (
                                <img
                                  src={attachment}
                                  alt="Attachment Preview"
                                  className="img-thumbnail"
                                  style={{ width: "100px", height: "100px" }}
                                />
                              )}
                            </div>
                          </div>
                        </>
                      )}
                      {banks.length > 0 && (
                        <div className="col-sm-12 mt-5">
                          <button
                            type="submit"
                            className="btn btn-primary btn-sm me-2"
                            id="submit"
                            disabled={referenceNumber.length < 12 || referenceNumber.length > 12}
                          >
                            Save
                          </button>
                          <Link
                            to="/deposits"
                            className="btn btn-default bordered btn-sm"
                          >
                            Cancel
                          </Link>
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default Deposit;
